__turbopack_context__.v({
  "ra-keyfacts": "ZHMzeq_ra-keyfacts",
  "ra-keyfacts__add-to-cart-helpertext": "ZHMzeq_ra-keyfacts__add-to-cart-helpertext",
  "ra-keyfacts__buttons": "ZHMzeq_ra-keyfacts__buttons",
  "ra-keyfacts__image": "ZHMzeq_ra-keyfacts__image",
  "ra-keyfacts__sidebar": "ZHMzeq_ra-keyfacts__sidebar",
  "ra-keyfacts__stepmap": "ZHMzeq_ra-keyfacts__stepmap",
  "ra-keyfacts__tab-panel": "ZHMzeq_ra-keyfacts__tab-panel",
});
